import React, { useState } from "react";
import { X } from "lucide-react";
import "./KeywordInput.css";


const KeywordInput = ({ keywords, onChange }) => {
  const [input, setInput] = useState("");

  const handleRemove = (keywordToRemove) => {
    onChange(keywords.filter((kw) => kw !== keywordToRemove));
  };


  return (
    <div className="tag-input-container">
      <div className="form-control tags">
        {keywords.map((kw) => (
          <span key={kw} className="tag">
            {kw}
            <X
              className="remove-icon"
              onClick={() => handleRemove(kw)}
              size={14}
            />
          </span>
        ))}
        <input
          type="text"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder="Add keyword..."
          disabled
        />
      </div>
    </div>
  );
};


export default KeywordInput;
